import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.broadcast}/rest/v2/message`, {
  get: {
    'get.broadcasts': '/messagePage',
    'get.broadcast.users': '/messageUsers',
    'get.broadcast.filters': '/filters'
  },
  post: {
    'post.save.broadcast': '/save'
  }
});

Request.register(`${Settings.api.clubUser}/v4`, {
  post: {
    'post.search.users.by.filter': '/search?page=:page&size=:size'
  }
});
